import type { KgInsightGeoSection } from '@api/api/kg-insights';
import { Badge } from '@design/components/badge/Badge';
import { FlagIcon } from '@design/components/flag-icon/FlagIcon';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import {
  GEO_SENTIMENT_BADGE_COLOR,
  GEO_SENTIMENT_LINEAR_GRADIENT_STYLE_MAP,
} from '../../kg-insight-constants';
import styles from './GeoExposureCards.module.scss';

type GeoCard = KgInsightGeoSection['data']['cards'][number];

export interface GeoExposureCardsProps {
  cards: GeoCard[];
}

export const GeoExposureCards = ({ cards }: GeoExposureCardsProps) => {
  const { t } = useTranslation(['insights', 'countries']);

  return (
    <div className={styles.root}>
      {cards.map(card => (
        <div
          key={`${card.name}-${card.sentiment}`}
          className={clsx(
            styles.card,
            GEO_SENTIMENT_LINEAR_GRADIENT_STYLE_MAP[card.sentiment]
          )}
        >
          <div className={styles.cardHeader}>
            <div className={styles.countryInfo}>
              <FlagIcon
                countryCode={card.code}
                variant="circular"
                customSize={28}
              />
              <span className={styles.countryName}>
                {t(`countries:${card.code}`)}
              </span>
            </div>
            <Badge
              color={GEO_SENTIMENT_BADGE_COLOR[card.sentiment]}
              size="small"
              label={t(
                'insights:catalystGeneration.reflexivityGraph.sentiment',
                { context: card.sentiment }
              )}
            />
          </div>
          <p className={styles.description}>{card.description}</p>
        </div>
      ))}
    </div>
  );
};
